var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseGridLayout',{attrs:{"size":"small"}},[_c('div',{staticClass:"col-span-full"},[_c('BaseList',{attrs:{"id":_vm.anchorName,"header":_vm.header,"items":_vm.downloadList,"type":"download","data-t-name":"download_list"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }